module.exports = __webpack_public_path__ + "assets/industry.6833a2b2.svg";